<aside class="sidebar" *ngIf="isAuthenticated()" [class.mobile-open]="isMobileMenuOpen">

  <!-- Logo Header -->
  <div class="sidebar-header">
    <div class="sidebar-logo" routerLink="/dashboard">
      <img [src]="themeService.isDark() ? 'assets/EZatwork.logo.1.2.png' : 'assets/blue-logo-trnsprnt-bg.png'"
           alt="EZ@Work" class="sidebar-logo-img">
    </div>

  </div>

  <!-- Workspace switcher -->
  <div class="workspace-switcher">
    <div class="ws-avatar">{{ userInitials }}</div>
    <span class="ws-name">{{ (currentUser())?.firstName || 'User' }}</span>
    <mat-icon class="ws-chevron">unfold_more</mat-icon>
  </div>

  <!-- Nav sections -->
  <nav class="nav-sections">

    <div class="nav-section">
      <div class="section-head">Workspace</div>
      <a *ngIf="hasNavItem('dashboard')" routerLink="/dashboard" routerLinkActive="active" (click)="closeMobileMenu()">
        <mat-icon>dashboard</mat-icon>
        <span>{{ 'nav.dashboard' | translate }}</span>
      </a>
      <a *ngIf="hasNavItem('clients')" routerLink="/clients" routerLinkActive="active" (click)="closeMobileMenu()">
        <mat-icon>business</mat-icon>
        <span>{{ 'nav.clients' | translate }}</span>
      </a>
      <a *ngIf="hasNavItem('projects')" routerLink="/projects" routerLinkActive="active" (click)="closeMobileMenu()">
        <mat-icon>{{ businessModeService.hasFeature('cases') ? 'gavel' : 'assignment' }}</mat-icon>
        <span>{{ businessModeService.getNavLabel('projects', 'nav.projects') | translate }}</span>
      </a>
      <a *ngIf="hasNavItem('tasks')" routerLink="/tasks" routerLinkActive="active" (click)="closeMobileMenu()">
        <mat-icon>check_box</mat-icon>
        <span>{{ 'nav.tasks' | translate }}</span>
      </a>
    </div>

    <!-- External tools — shown when the vertical has links for the current country -->
    <div class="nav-section" *ngIf="businessModeService.getExternalLinks().length > 0">
      <div class="section-head">{{ businessModeService.getToolsLabel() | translate }}</div>
      <ng-container *ngFor="let link of businessModeService.getExternalLinks()">
        <ng-container *ngIf="link.searchUrl; else directLink">
          <button class="nav-link-btn"
                  [matMenuTriggerFor]="searchPanel"
                  (menuOpened)="setActiveSearchLink(link)">
            <mat-icon>{{ link.icon }}</mat-icon>
            <span>{{ link.label }}</span>
            <mat-icon class="ext-icon">search</mat-icon>
          </button>
        </ng-container>
        <ng-template #directLink>
          <a [href]="link.url" target="_blank" rel="noopener" (click)="closeMobileMenu()">
            <mat-icon>{{ link.icon }}</mat-icon>
            <span>{{ link.label }}</span>
            <mat-icon class="ext-icon">open_in_new</mat-icon>
          </a>
        </ng-template>
      </ng-container>
    </div>

    <mat-menu #searchPanel="matMenu" class="nav-search-menu">
      <div class="nav-search-panel" (click)="$event.stopPropagation()">
        <mat-icon class="search-icon">search</mat-icon>
        <input #navSearchInput
               class="nav-search-input"
               [placeholder]="'nav.searchIn' | translate: { name: activeSearchLink?.label }"
               (keydown.enter)="openNavSearch(navSearchInput.value)">
        <button mat-icon-button class="nav-search-go" (click)="openNavSearch(navSearchInput.value)">
          <mat-icon>arrow_forward</mat-icon>
        </button>
      </div>
    </mat-menu>

    <div class="nav-section">
      <div class="section-head">Money</div>
      <a *ngIf="hasNavItem('time-tracking')" routerLink="/finance/time-tracking" routerLinkActive="active" (click)="closeMobileMenu()">
        <mat-icon>timer</mat-icon>
        <span>{{ 'nav.timeTracking' | translate }}</span>
      </a>
      <a *ngIf="hasNavItem('invoices')" routerLink="/finance/invoices" routerLinkActive="active" (click)="closeMobileMenu()">
        <mat-icon>receipt</mat-icon>
        <span>{{ 'nav.invoices' | translate }}</span>
      </a>
      <a *ngIf="hasNavItem('transactions')" routerLink="/finance/transactions" routerLinkActive="active" (click)="closeMobileMenu()">
        <mat-icon>account_balance_wallet</mat-icon>
        <span>{{ 'nav.transactions' | translate }}</span>
      </a>
      <a *ngIf="hasNavItem('reports')" routerLink="/finance/reports" routerLinkActive="active" (click)="closeMobileMenu()">
        <mat-icon>bar_chart</mat-icon>
        <span>{{ 'nav.reports' | translate }}</span>
      </a>
      <a *ngIf="hasNavItem('contracts')" routerLink="/contracts" routerLinkActive="active" (click)="closeMobileMenu()">
        <mat-icon>description</mat-icon>
        <span>{{ 'nav.contracts' | translate }}</span>
      </a>
    </div>


  </nav>

  <!-- Sidebar footer: notification + user -->
  <div class="sidebar-footer">

    <!-- Admin button -->
    <button *ngIf="isAdmin"
            mat-icon-button
            [matMenuTriggerFor]="adminMenu"
            class="admin-btn"
            matTooltip="Admin Panel">
      <mat-icon>admin_panel_settings</mat-icon>
    </button>

    <mat-menu #adminMenu="matMenu" class="admin-dropdown">
      <div class="admin-menu-header">
        <mat-icon>admin_panel_settings</mat-icon>
        <span>{{ 'nav.adminPanel' | translate }}</span>
      </div>
      <mat-divider></mat-divider>
      <button mat-menu-item routerLink="/admin/users">
        <mat-icon>people</mat-icon>{{ 'nav.adminUsers' | translate }}
      </button>
      <button mat-menu-item routerLink="/admin/reviews">
        <mat-icon>rate_review</mat-icon>{{ 'nav.adminReviews' | translate }}
      </button>
      <button mat-menu-item routerLink="/admin/logs">
        <mat-icon>receipt_long</mat-icon>{{ 'nav.adminLogs' | translate }}
      </button>
      <mat-divider></mat-divider>
      <button mat-menu-item routerLink="/email">
        <mat-icon>email</mat-icon>{{ 'nav.bulkEmail' | translate }}
      </button>
    </mat-menu>

    <!-- Notification bell -->
    <app-notification-bell></app-notification-bell>

    <!-- User row -->
    <div class="user-row" [matMenuTriggerFor]="userMenu">
      <div class="user-avatar-wrap">
        <img *ngIf="(currentUser())?.avatarUrl; else defaultAvatar"
             [src]="(currentUser())?.avatarUrl"
             alt="avatar"
             class="user-avatar"
             (error)="onAvatarError($event)">
        <ng-template #defaultAvatar>
          <div class="default-avatar">{{ userInitials }}</div>
        </ng-template>
      </div>
      <span class="user-display-name">{{ (currentUser())?.firstName || 'User' }}</span>
      <mat-icon class="user-more">more_horiz</mat-icon>
    </div>

    <mat-menu #userMenu="matMenu" class="user-dropdown">
      <button mat-menu-item routerLink="/profile">
        <mat-icon>person</mat-icon>{{ 'nav.profile' | translate }}
      </button>
      <button mat-menu-item routerLink="/business-settings">
        <mat-icon>business</mat-icon>{{ 'nav.businessSettings' | translate }}
      </button>
      <button mat-menu-item routerLink="/settings">
        <mat-icon>settings</mat-icon>{{ 'nav.settings' | translate }}
      </button>
      <button mat-menu-item (click)="openSupport()">
        <mat-icon>support_agent</mat-icon>{{ 'nav.support' | translate }}
      </button>
      <button mat-menu-item routerLink="/pricing">
        <mat-icon>workspace_premium</mat-icon>{{ 'nav.pricing' | translate }}
      </button>
      <button *ngIf="isDemo"
              mat-menu-item
              (click)="tourService.restart()">
        <mat-icon>explore</mat-icon>{{ 'tour.restartBtn' | translate }}
      </button>
      <mat-divider></mat-divider>
      <!-- Theme submenu -->
      <button mat-menu-item [matMenuTriggerFor]="themeMenu">
        <mat-icon>{{ themeService.isDark() ? 'dark_mode' : 'light_mode' }}</mat-icon>
        {{ 'nav.theme' | translate }}
      </button>
      <!-- Language submenu -->
      <button mat-menu-item [matMenuTriggerFor]="languageMenu">
        <mat-icon>language</mat-icon>
        {{ 'nav.language' | translate }}
      </button>
      <mat-divider></mat-divider>
      <button mat-menu-item (click)="logout()">
        <mat-icon>logout</mat-icon>{{ 'nav.logout' | translate }}
      </button>
    </mat-menu>

    <mat-menu #languageMenu="matMenu" class="lang-submenu">
      <button mat-menu-item
              *ngFor="let lang of availableLanguages"
              (click)="setLanguage(lang.code)">
        {{ lang.nativeName }}
      </button>
    </mat-menu>

    <mat-menu #themeMenu="matMenu">
      <button mat-menu-item (click)="setTheme('light')">
        <mat-icon>light_mode</mat-icon>{{ 'nav.themeLight' | translate }}
      </button>
      <button mat-menu-item (click)="setTheme('dark')">
        <mat-icon>dark_mode</mat-icon>{{ 'nav.themeDark' | translate }}
      </button>
      <button mat-menu-item (click)="setTheme('system')">
        <mat-icon>contrast</mat-icon>{{ 'nav.themeSystem' | translate }}
      </button>
    </mat-menu>


  </div>
</aside>
